import React, { Component } from 'react'
import PlanningReviewTool from '../../components/PlanningReviewTool/PlanningReviewTool';
import { getAllImplantsService, getAllRegions, getPlanningResultService } from '../../services/java/java-services';
import { planningToolErrorMessages, actions, loggerEventTypes, loggerEventOutcome, loggerEventName } from '../../helpers/messages';
import { logger } from '../../services/logger/logger-service';
let startDate;

const DEFAULTS = {
	preopDeformity: { min: -8, max: 8, minVal: 0, maxVal: 3 },
	femurSize: { min: 1, max: 10 },
	patientAge: { min: 0, max: 101, minVal: 0, maxVal: 0, maxLabel: "> 100" },
}

export default class PlanningReviewToolContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			caseData: null,
			caseData2: null,
			implants: [],
			regions: [],
			defaultRegion: '',
			defaultRegion2: '',
			selectedRegion: '',
			selectedRegion2: '',
			loading: false,
			femurSizeRange: {
				min: 1,
				max: 10
			},
			preopDeformity: { min: DEFAULTS.preopDeformity.minVal, max: DEFAULTS.preopDeformity.maxVal },
			femurSize: { min: '', max: '' },
			patientAge: { min: DEFAULTS.patientAge.min, max: DEFAULTS.patientAge.max },
			patientSex: '',
			tensionerForce: ['high', 'medium', 'low'],
			implant: '',
			gapsCollectedPlanningTool: '',
			casePull: 'myCases',
			casePull2: 'globalCases',
			showResults: false,
			disableReset: true,
			disableFilter: false,
			invalidFilters: true,
			error: '',
			planningToolError: null,
			planningToolError2: null,
			implantError: null,
			regionError: null,
			loggerObj: {
				"EventOutcome": loggerEventOutcome.success,
				"EventType": loggerEventTypes.read,
				"EventName": loggerEventName.planningTool,
				"StartDate": new Date()
			}
		};
	}

	componentDidMount() {
		this.getAllImplants();
		this.getAllRegions();
		// initialize the start date on page load
		startDate = new Date();
		window.addEventListener('beforeunload', this.applicationLogger);
	}

	componentWillUnmount() {
		window.removeEventListener('beforeunload', this.applicationLogger);
		this.applicationLogger();
	}

	/**
	 * @description function to handle application logs
	 * @param {*}
	 * @memberof PlanningReviewToolContainer
	 */
	applicationLogger = (key) => {
		// calculate the time since we loaded this page
		const timeSinceLoad = (new Date().getTime() - startDate.getTime()) / 1000;
		const loggerObj = {
			"EventOutcome": loggerEventOutcome.success,
			"EventType": loggerEventTypes.read,
			"EventName": loggerEventName.planningTool,
			"Content": {
				"TimeSpent": timeSinceLoad
			}
		}
		logger(loggerObj);
	}

	/**
	 * @description function to get the all implant types
	 * @memberof PlanningReviewToolContainer
	 */
	getAllImplants = async () => {
		this.setState({ loading: true });
		getAllImplantsService((err, result) => {
			if (err) {
				this.setState({ loading: false, implantError: err });
			} else {
				this.setState({
					loading: false,
					implants: result.data.case,
					implantError: null
				})
			}
		})
	}

	/**
	 * @description function to get the all market regions
	 * @memberof PlanningReviewToolContainer
	 */
	getAllRegions = async () => {
		this.setState({ loading: true });
		getAllRegions((err, result) => {
			if (err) {
				this.setState({ loading: false, regionError: err });
			} else {
				const res = result?.data?.case?.length ? result.data.case[0] : null;
				var regions = res?.regions?.length ? res.regions : [];
				var defaultRegion = res?.defaultregion || ''
				var defaultRegion2 = regions?.length ? regions.find(x => x.name !== defaultRegion)?.name : defaultRegion;
				this.setState({
					regions,
					defaultRegion,
					defaultRegion2,
					selectedRegion: defaultRegion,
					selectedRegion2: defaultRegion,
					regionError: null
				});
			}
		})
	}

	/**
	 * @description Function to handle changes in the range input
	 * @param values The min and max value selected in array format
	 * @param field The field for which the range is being selected
	 * @memberof PlanningReviewToolContainer
	 */
	handleRangeChange = (values, field) => {
		let obj = {};
		if (values.length) {
			obj[field] = {
				min: values[0],
				max: values[1]
			};
		} else {
			obj[field] = { min: '', max: '' };
		}

		setTimeout(() => {
			this.setState({
				...obj,
				...this.validateReviewFilters()
			});
		}, 0);
	}

	/**
	 * @description Function to handle changes in the other form inputs
	 * @param values The value being input in the field
	 * @param field The field for which the value is being input
	 * @memberof PlanningReviewToolContainer
	 */
	handleInputChange = (value, field) => {

		var stateObj = { [field]: value };
		if (field === 'implant') {
			stateObj = {
				...stateObj,
				...this.setFemurSizeRange(value)
			};
		}

		if (field === 'casePull') {
			let { casePull, casePull2, defaultRegion, defaultRegion2, selectedRegion, selectedRegion2 } = this.state;
			if (value === casePull) {
				return;
			}
			if (value === 'region') {
				stateObj['selectedRegion'] = (casePull2 === 'region' && selectedRegion2 === defaultRegion) ? defaultRegion2 : selectedRegion;
			}
		}

		if (field === 'casePull2') {
			let { casePull, casePull2, defaultRegion, defaultRegion2, selectedRegion, selectedRegion2 } = this.state;
			if (value === casePull2) {
				return;
			}
			if (value === 'region') {
				stateObj['selectedRegion2'] = (casePull === 'region' && selectedRegion === defaultRegion) ? defaultRegion2 : selectedRegion2;
			}
		}

		this.setState({
			...stateObj,
			...this.validateReviewFilters()
		})
	}

	/**
	 * @description Function to set femur size range limits based on implant selection
	 * @param implant The value of selected implant
	 * @memberof PlanningReviewToolContainer
	 */
	setFemurSizeRange = (implant) => {
		const selectedImplant = this.state.implants.find(x => x.name === implant);
		const obj = {
			min: selectedImplant ? Math.min(...selectedImplant.femurSize) : 1,
			max: selectedImplant ? Math.max(...selectedImplant.femurSize) : 10
		}

		return { femurSizeRange: obj, femurSize: { min: '', max: '' } }
	}

	/**
	 * @description Function to handle validation from the filters, at least one input should be there
	 * @memberof PlanningReviewToolContainer
	 */
	validateReviewFilters = () => {
		const { preopDeformity, femurSize, patientAge, patientSex, implant, casePull, casePull2, gapsCollectedPlanningTool, tensionerForce, error } = this.state;
		const otherInputValidate = femurSize.min === '' && femurSize.max === '' && patientAge.min === '' && patientAge.max === '' &&
			!patientSex.length && !tensionerForce.length && implant === '' && gapsCollectedPlanningTool === '' && casePull === 'myCases' && casePull2 === 'globalCases';
		const isEmptyFilters = preopDeformity.min === '' && preopDeformity.max === '' && otherInputValidate;
		const invalidFilters = implant === '';
		const disableReset = preopDeformity.min === DEFAULTS.preopDeformity.minVal && preopDeformity.max === DEFAULTS.preopDeformity.maxVal && otherInputValidate;

		return {
			disableReset: disableReset,
			disableFilter: isEmptyFilters,
			invalidFilters: invalidFilters,
			error: invalidFilters ? error : ''
		}
	}

	/**
	 * @description Function to submit the filters
	 * @memberof PlanningReviewToolContainer
	 */
	handleSubmit = () => {
		const validationObj = this.validateReviewFilters();
		if (validationObj.invalidFilters) {
			this.setState({
				...validationObj,
				showResults: false,
				error: planningToolErrorMessages.implantMandatory
			});
		} else {
			this.setState(validationObj);
			setTimeout(() => {
				this.fetchPlanningResults();
			}, 0);
		}
	}

	/**
	 * @description Function to return a comma separated list of all femursize selections
	 * @memberof PlanningReviewToolContainer
	 */
	getFemurSizeForFilter = () => {
		const min = this.state.femurSize.min !== '' ? this.state.femurSize.min : this.state.femurSizeRange.min;
		const max = this.state.femurSize.max !== '' ? this.state.femurSize.max : this.state.femurSizeRange.max;
		var femurSizeArray = [];
		for (let i = min; i <= max; i++) {
			femurSizeArray.push(i);
		}

		return femurSizeArray.join(',');
	}

	/**
	 * @description Function to create common filters for both sections
	 * @memberof PlanningReviewToolContainer
	 */
	getCommonFilters = () => {
		const { preopDeformity, patientAge, patientSex, implant, gapsCollectedPlanningTool, tensionerForce } = this.state;
		var commonFilterObj = {
			deformityfrom: preopDeformity.min !== '' ? preopDeformity.min : DEFAULTS.preopDeformity.min,
			deformityto: preopDeformity.max !== '' ? preopDeformity.max : DEFAULTS.preopDeformity.max,
			implant: implant,
			femursize: this.getFemurSizeForFilter()
		}

		if (parseInt(patientAge.min) >= 0 && parseInt(patientAge.max) > 0) {
			commonFilterObj['agemin'] = patientAge.min ? patientAge.min : DEFAULTS.patientAge.minVal;
			commonFilterObj['agemax'] = patientAge.max ? patientAge.max : DEFAULTS.patientAge.maxVal;
		}

		if (patientSex && patientSex.length) {
			commonFilterObj['patientsex'] = patientSex.join(',');
		}
		if (gapsCollectedPlanningTool && gapsCollectedPlanningTool.length) {
			commonFilterObj['gapsCollected'] = gapsCollectedPlanningTool;

		}
		if (gapsCollectedPlanningTool && gapsCollectedPlanningTool.toLowerCase() === 'tensioner' && tensionerForce && tensionerForce.length) {
			commonFilterObj['tensionerforce'] = tensionerForce.join(',');
		}

		return commonFilterObj;
	}

	/**
	 * @description Function to fetch results based on filters
	 * @memberof PlanningReviewToolContainer
	 */
	fetchPlanningResults = async () => {
		const { casePull, casePull2, selectedRegion, selectedRegion2 } = this.state;
		var commonFilterObj = this.getCommonFilters()

		var paramsFirstSet = {
			...commonFilterObj,
			type: casePull.toLowerCase()
		}

		var paramsSecondSet = {
			...commonFilterObj,
			type: casePull2.toLowerCase()
		}

		if (casePull.toLowerCase() === 'region') {
			paramsFirstSet['region'] = selectedRegion;
		}

		if (casePull2.toLowerCase() === 'region') {
			paramsSecondSet['region'] = selectedRegion2;
		}

		this.setState({ loading: true })
		const resArray = await Promise.allSettled([
			this.callFetchDataAPI(paramsFirstSet),
			this.callFetchDataAPI(paramsSecondSet)
		]);
		const [resFirstSet, resSecondSet] = resArray;
		var dataSet1 = {}
		var dataSet2 = {}

		switch (resFirstSet.status) {
			case 'fulfilled':
				dataSet1 = {
					caseData: resFirstSet?.value?.data?.case?.length ? resFirstSet?.value?.data?.case[0] : null,
					planningToolError: null
				}
				break;
			case 'rejected':
				dataSet1 = {
					caseData: null,
					planningToolError: resFirstSet.reason
				}
				break;

			default:
				break;
		}
		switch (resSecondSet.status) {
			case 'fulfilled':
				dataSet2 = {
					caseData2: resSecondSet?.value?.data?.case?.length ? resSecondSet?.value?.data?.case[0] : null,
					planningToolError2: null
				}
				break;
			case 'rejected':
				dataSet2 = {
					caseData2: null,
					planningToolError2: resSecondSet.reason
				}
				break;

			default:
				break;
		}

		this.setState({
			loading: false,
			showResults: true,
			...dataSet1,
			...dataSet2
		})
		setTimeout(() => {
			// Scroll to the bottom so that the results are focused.
			window.scrollTo(0, document.body.scrollHeight);
		}, 0);
	}

	/**
	 * @description Function to handle the API call to fetch data
	 * @param params The filters to be sent as get params
	 * @memberof PlanningReviewToolContainer
	 */
	callFetchDataAPI = (params) => {
		return new Promise((resolve, reject) => {
			getPlanningResultService(params, (err, res) => {
				if (err) {
					return reject(err);
				} else {
					return resolve(res)
				}
			})
		})
	}

	/**
	 * @description Function to handle change in one data section from the case pull dropdown
	 * @param casePullType The dataset to fetch (my cases, global cases, my country or regional)
	 * @param field The row for which data needs to be fetched
	 * @param region The selected region for the section (only for regional data fetch)
	 * @memberof PlanningReviewToolContainer
	 */
	handleChangeSection = (casePullType, field, region) => {
		if (!region && casePullType === this.state[field]) {
			return;
		}
		if (region && region === this.state[field]) {
			return;
		}
		const { casePull, casePull2, defaultRegion, defaultRegion2, selectedRegion, selectedRegion2 } = this.state;
		var params = this.getCommonFilters();
		var stateObj = { loading: true };
		var caseDataFieldName = 'caseData';
		var errorFieldName = 'planningToolError';
		params['type'] = casePullType.toLowerCase();


		switch (field) {
			case 'casePull':
				if (casePullType === 'region') {
					stateObj['selectedRegion'] = params['region'] = (casePull2 === 'region' && selectedRegion2 === defaultRegion) ? defaultRegion2 : selectedRegion;
				}
				stateObj[field] = casePullType;
				caseDataFieldName = 'caseData';
				errorFieldName = 'planningToolError';
				break;
			case 'casePull2':
				if (casePullType === 'region') {
					stateObj['selectedRegion2'] = params['region'] = (casePull === 'region' && selectedRegion === defaultRegion) ? defaultRegion2 : selectedRegion2;
				}
				stateObj[field] = casePullType;
				caseDataFieldName = 'caseData2';
				errorFieldName = 'planningToolError2';
				break;
			case 'selectedRegion':
			case 'selectedRegion2':
				caseDataFieldName = (field === 'selectedRegion') ? 'caseData' : 'caseData2';
				errorFieldName = (field === 'selectedRegion') ? 'planningToolError' : 'planningToolError2';
				params['region'] = region ? region : this.state[field];
				stateObj[field] = region ? region : this.state[field];
				break;

			default:
				break;
		}
		this.setState(stateObj);
		this.callFetchDataAPI(params).then(res => {
			this.setState({
				loading: false,
				[caseDataFieldName]: res?.data?.case?.length ? res?.data?.case[0] : null,
				[errorFieldName]: null
			});
		}).catch(err => {
			this.setState({
				loading: false,
				[caseDataFieldName]: null,
				[errorFieldName]: err
			});
		})
	}

	/**
	 * @description Function to reset the filters
	 * @param {values, field}
	 * @memberof PlanningReviewToolContainer
	 */
	handleReset = () => {
		const { defaultRegion } = this.state;
		this.setState({
			femurSizeRange: { min: 1, max: 10 },
			preopDeformity: { min: DEFAULTS.preopDeformity.minVal, max: DEFAULTS.preopDeformity.maxVal },
			femurSize: { min: '', max: '' },
			patientAge: { min: DEFAULTS.patientAge.min, max: DEFAULTS.patientAge.max },
			patientSex: '',
			tensionerForce: ['high', 'medium', 'low'],
			implant: '',
			gapsCollectedPlanningTool: '',
			casePull: 'myCases',
			casePull2: 'globalCases',
			selectedRegion: defaultRegion,
			selectedRegion2: defaultRegion,
			showResults: false,
			disableReset: true,
			disableFilter: false,
			error: '',
			planningToolError: '',
			planningToolError2: ''
		});
	}

	render() {
		const { loggerObj, femurSizeRange, implants, regions, selectedRegion, selectedRegion2, gapsCollectedPlanningTool, caseData, caseData2, showResults, showResults2, error, loading,
			disableReset, disableFilter, planningToolError, planningToolError2 } = this.state;
		return (
			<>
				{loading ? <div className="loading-overlay"><span>{actions.load}</span></div> : null}
				<PlanningReviewTool
					caseData={caseData}
					caseData2={caseData2}
					isLoading={loading}
					femurSizeRange={femurSizeRange}
					implants={implants}
					regions={regions}
					selectedRegion={selectedRegion}
					selectedRegion2={selectedRegion2}
					showResults={showResults}
					showResults2={showResults2}
					defaults={DEFAULTS}
					disableFilter={disableFilter}
					disableReset={disableReset}
					error={error}
					handleRangeChange={this.handleRangeChange}
					handleInputChange={this.handleInputChange}
					handleSubmit={this.handleSubmit}
					handleReset={this.handleReset}
					handleChangeSection={this.handleChangeSection}
					loggerObj={loggerObj}
					planningToolError={planningToolError}
					planningToolError2={planningToolError2}
					gapsCollectedPlanningTool={gapsCollectedPlanningTool}
				/>
			</>
		)
	}
}
